"use client"
import "./CountryTabs.css"

const CountryTabs = ({ activeTab, setActiveTab, country }) => {
  const tabs = [
    "FAST FACTS",
    "TOP UNIVERSITIES",
    "ADMISSIONS",
    "SCHOLARSHIPS",
    "VISA",
    "COST OF LIVING",
    "WORK OPPORTUNITIES",
    "FAQS",
  ]

  return (
    <div className="country-tabs">
      <div className="tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  )
}

export default CountryTabs
